import axios from "axios";
import {baseUrl} from "./base.api.ts";

// Guest messaging API. Uses its own axios instance: it must never send the
// regular login token, and guest tokens never go to the regular API.
const guestApi = axios.create({
    baseURL: baseUrl,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
    timeout: 30000,
});

const auth = (token) => ({headers: {Authorization: `Bearer ${token}`}});

export const createGuestInquiry = async (payload) => {
    const res = await guestApi.post("guest/inquiries", payload);
    return res.data.data;
};

export const redeemGuestLink = async (token) => {
    const res = await guestApi.post("guest/session", {token});
    return res.data.data;
};

export const getGuestConversations = async (token) => {
    const res = await guestApi.get("guest/conversations", auth(token));
    return res.data.data;
};

export const getGuestMessages = async (token, conversationId) => {
    const res = await guestApi.get(`guest/conversations/${encodeURIComponent(conversationId)}/messages`, auth(token));
    return res.data.data;
};

export const sendGuestReply = async (token, conversationId, payload) => {
    const res = await guestApi.post(`guest/conversations/${encodeURIComponent(conversationId)}/messages`, payload, auth(token));
    return res.data;
};

// Quick booking (no account yet). Same instance: no regular token is sent.
export const getQuickBookingPrice = async (payload) => {
    const res = await guestApi.post("guest/booking/price", payload);
    return res.data;
};

export const sendQuickBookingCode = async (payload) => {
    const res = await guestApi.post("guest/booking/send-code", payload);
    return res.data;
};

export const verifyQuickBooking = async (payload) => {
    const res = await guestApi.post("guest/booking/verify", payload);
    return res.data;
};

// Code login for existing accounts: the code goes to the phone confirmed on
// the account. {identifier, turnstile_token} -> {phone_last4}
export const sendLoginCode = async (payload) => {
    const res = await guestApi.post("guest/login/send-code", payload);
    return res.data;
};

// {identifier, code} -> same tokens as the password login
export const verifyLoginCode = async (payload) => {
    const res = await guestApi.post("guest/login/verify", payload);
    return res.data;
};

/** User-facing message from a guest API error. */
export const guestErrorMessage = (error, fallback = "Something went wrong. Please try again.") =>
    error?.response?.data?.message || fallback;

export const guestErrorCode = (error) => error?.response?.data?.error || "";

// Guest session (from a sign-in link) stored separately from the regular token.
const SESSION_KEY = "teache_guest_session";

export const guestSession = {
    get() {
        try {
            const s = JSON.parse(window.localStorage.getItem(SESSION_KEY));
            if (!s?.token || new Date(s.expires_at) <= new Date()) return null;
            return s;
        } catch {
            return null;
        }
    },
    set(session) {
        try {
            window.localStorage.setItem(SESSION_KEY, JSON.stringify(session));
        } catch {
            // ignore
        }
    },
    clear() {
        try {
            window.localStorage.removeItem(SESSION_KEY);
        } catch {
            // ignore
        }
    },
};
